/** Anchors `CreateQuoteTemplateButton`'s modal so an external link can open
 *  straight into it — used by the picker's zero-result "Create a new
 *  template" exit (design D9). Its own module so consumers on the lighter
 *  side (the zero-result panels) don't have to pull in the button's own
 *  heavy import tree (mutations, the modal, capability checks) just for
 *  this one string. */
export const CREATE_TEMPLATE_URL_PARAM = "createTemplate";
